import React from 'react';
import raf from "rc-util/es/raf";
const ELEMENT_GAP = 2;
const adjustElementWidth = (width, wrapper) => {
  if (wrapper.offsetWidth - width < ELEMENT_GAP) {
    // The textarea's width is increased
    wrapper.style.width = `${width + ELEMENT_GAP}px`;
  } else if (wrapper.offsetWidth - width > ELEMENT_GAP) {
    // The textarea's width is decreased
    wrapper.style.width = `${width + ELEMENT_GAP}px`;
  }
};
const useHandleResizeWrapper = () => {
  const handleResizeWrapper = React.useCallback(rcTextArea => {
    if (!rcTextArea) {
      return;
    }
    if (rcTextArea.resizableTextArea.textArea.style.width.includes('px')) {
      const width = Number.parseInt(rcTextArea.resizableTextArea.textArea.style.width.replace(/px/, ''));
      raf(() => adjustElementWidth(width, rcTextArea.nativeElement));
    }
  }, []);
  return handleResizeWrapper;
};
export default useHandleResizeWrapper;